import { IBuilder } from '../../types/builders';
import { IApplicationState } from '../../types/redux';

export function getBuildersList(state: IApplicationState): IBuilder[] | null {
  const { buildersList } = state;

  if (buildersList?.constructorsList.length) {
    return buildersList.constructorsList;
  }

  return null;
}
